module.exports = __webpack_public_path__ + "img/TP.54d62852.jpg";